export default
    {
        path:'/cms/list/:id',
        mapPath:'/cms/list',
        component: require('./index').default,
        parent:'root',
    }
